var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('LinkWithIcon',{attrs:{"settings":_vm.settings,"styles":_vm.linkStyles,"hideIcons":_vm.hideIcons},on:{"clicked":_vm.clicked}}),(_vm.isLastRanked)?_c('br'):_vm._e(),(_vm.isLastRanked)?_c('span',{staticClass:"last-ranked",domProps:{"innerHTML":_vm._s(_vm.settings.lastRanked)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }